export default "__VITE_ASSET__BWLXyR9___"